import theme from '../theme'
import { createTheme } from '@material-ui/core/styles'

const defaultMaterialTheme = createTheme({
  overrides: {
    MuiPickersCalendarHeader: {
      switchHeader: {
        color: theme.palette.primary.main,
        textTransform: 'uppercase',
      },
      dayLabel: {
        textTransform: 'uppercase',
        color: '#707070',
      },
    },
    MuiPickersDay: {
      day: {
        // TODO: this color isn't in theme ask UI/UX to add or define
        color: '#707070',
      },
      daySelected: {
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
        },
      },
      current: {
        color: theme.palette.primary.main,
      },
    },
    MuiSvgIcon: {
      root: {
        fill: theme.palette.primary.main,
      },
    },
  },
})

export default defaultMaterialTheme
